import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Box,
} from '@mui/material';
import PhoneShape from 'app/shapes/PhoneShape';

import AddPhoneContainer from 'app/containers/AddPhoneContainer';

const AddPhoneStep = ({ currentUser, phones, afterCancel, afterSuccess }) => {
  // TODO: Matt, clean up the display of the AddPhoneContainer component here
  // Maybe change flexDirection to column and center the content
  // Fix the background color to match the rest of the page

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <AddPhoneContainer
          afterCancel={afterCancel}
          afterSuccess={afterSuccess}
          currentUser={currentUser}
          phones={phones}
          setShowAddPhoneNumber={(_value) => {}}
        />
      </Box>
    </Container>
  );
};

AddPhoneStep.defaultProps = {
  phones: [],
};

AddPhoneStep.propTypes = {
  afterCancel: PropTypes.func.isRequired,
  afterSuccess: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  phones: PropTypes.arrayOf(PhoneShape),
};

export default AddPhoneStep;
